const resetCallbacks = new Set();
export const registerResetCallback = (callback) => {
    resetCallbacks.add(callback);
};
export const runResetCallbacks = () => {
    resetCallbacks.forEach((callback) => callback());
};
